import { makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  selectorBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginLeft: 10,
    marginTop: 10,
    marginRight: 10,
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
}));
